import { defineStore } from "pinia";
import * as _debug from "debug";
import ApiClient from "@/lib/ApiClient";
import { createStore } from "../storeHelper";
import _ from "lodash";

const debug = _debug(`${process.env.VUE_APP_PREFIX}:FeaturesStore`);

export const useFeaturesStore = defineStore(
  "features",
  createStore({
    state: {
      features: {},
    },

    getters: {
      featuresList: (state) => _.values(state.features),
    },

    actions: {
      async load() {
        debug("load");
        const features = await ApiClient.get(`/features`);
        debug("load", features);
        this.set("features", _.keyBy(features, "technicalIdentifier"));
      },
    },
  }),
);
